import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class GetIncomeOutcomePercentChart extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("IncomeOutcomeTransaction/GetPercentChartGeneral");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetIncomeOutcomeChart extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("IncomeOutcomeTransaction/GetChartGeneral");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetMasterIncomeOutcomeList extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("IncomeOutcomeTransaction/GetMasterIncomeOutcomeList");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

export {
  GetIncomeOutcomePercentChart,
  GetIncomeOutcomeChart,
  GetMasterIncomeOutcomeList,
};
